export default "__VITE_ASSET__00$hfl0z__"